module.exports = __webpack_public_path__ + "static/media/Asset 3hip X-ray Chart.93c0ac04.png";